import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import after from 'lodash/after';
import { computed, observable, reaction, runInAction } from 'mobx';
import { interval, merge, NEVER, Observable, of, Subscription } from 'rxjs';
import { distinctUntilChanged, first, map, switchMap, switchMapTo } from 'rxjs/operators';
import Workspace from '../iam/Workspace';
import { PageActivity, pageActivityStream } from '../utils/domUtil';

/**
 * Tracks session information such as the current user and workspace.
 */
var SessionStore = (_class = /*#__PURE__*/function (_Store) {
  /**
   * Constructor.
   */
  function SessionStore() {
    var _this;
    _classCallCheck(this, SessionStore);
    _this = _callSuper(this, SessionStore, arguments);
    /**
     * Current workspace.
     */
    _initializerDefineProperty(_this, "workspace", _descriptor, _this);
    /**
     * Subscription for disposing.
     */
    _this.subscription = new Subscription();
    _this.dispose = function () {
      return _this.subscription.unsubscribe();
    };
    if (window.__workspaceDomain) {
      _this.rootStore.workspaceStore.workspaces.set(_objectSpread(_objectSpread({}, window.__workspaceDomain.workspace), {}, {
        isDomainMatchedWorkspace: true
      }));
    }
    _this.pageActivity$ = pageActivityStream();
    _this.workspace$ = toStream(function () {
      return _this.workspace;
    }, true);
    _this.ping$ = _this.workspace$.pipe(first(function (v) {
      return v !== null;
    }), switchMapTo(merge(of(PageActivity.Active), _this.pageActivity$).pipe(map(function (a) {
      return Boolean(a === PageActivity.Active);
    }),
    // turn the condition into bools, easier to work with
    distinctUntilChanged(),
    // turn "true, true, false, false, true" into "true, false, true"
    switchMap(function (active) {
      return !active ?
      // Not active, so do nothing. Because we use switchMap, the previous
      // interval (if any) has stopped
      NEVER :
      // Active, so emit every 2 minutes
      interval(120000);
    }))));
    _this.subscription.add(_this.ping$.subscribe(function () {
      _this.updateLastSeen(_this.workspace.id);
    }));
    return _this;
  }
  _inherits(SessionStore, _Store);
  return _createClass(SessionStore, [{
    key: "user",
    get:
    /**
     * The current user (NOT workspace member)
     */
    function get() {
      return this.rootStore.authStore.user;
    }

    /**
     * The current workspace member.
     */
  }, {
    key: "member",
    get: function get() {
      var user = this.user;
      return this.workspace && user ? this.rootStore.memberStore.forWorkspaceAndUserPublicId(this.workspace.id, user.userPublicId) : null;
    }
  }, {
    key: "teamMembers",
    get: function get() {
      var user = this.user;
      return this.workspace && user ? this.rootStore.teamMemberStore.teamMembersForWorkspaceMemberByPublicId(this.workspace.id, user.userPublicId) : [];
    }

    /**
     * Gets the current member in the specified workspace.
     */
  }, {
    key: "memberIn",
    value: function memberIn(workspaceOrWorkspaceId) {
      var workspaceId = workspaceOrWorkspaceId instanceof Workspace ? workspaceOrWorkspaceId.id : workspaceOrWorkspaceId;
      return this.rootStore.memberStore.forWorkspaceAndUserPublicId(workspaceId, this.user.public_id);
    }
  }, {
    key: "updateLastSeen",
    value: function () {
      var _updateLastSeen = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.rootStore.memberStore.updateLastSeen(id);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function updateLastSeen(_x) {
        return _updateLastSeen.apply(this, arguments);
      }
      return updateLastSeen;
    }()
    /**
     * Selects the specified workspace.
     *
     * @param {*} idOrObj
     */
  }, {
    key: "selectWorkspace",
    value: (function () {
      var _selectWorkspace = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(idOrObj) {
        var _this2 = this;
        var id, _yield$Promise$all, _yield$Promise$all2, workspace;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              id = typeof idOrObj === 'string' ? idOrObj : idOrObj.id;
              _context2.next = 3;
              return Promise.all([this.rootStore.workspaceStore.fetchWorkspace(id), this.rootStore.memberStore.fetchByPublicId({
                workspace_id: id,
                user_public_id: this.rootStore.authStore.user.userPublicId
              }), this.rootStore.translationStore.fetchAll(id)]);
            case 3:
              _yield$Promise$all = _context2.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
              workspace = _yield$Promise$all2[0];
              runInAction(function () {
                _this2.workspace = workspace;
              });

              // clear cache before getting team members
              this.rootStore.teamMemberStore.fetchUserTeamMembersByPublicId.clear();
              _context2.next = 10;
              return this.rootStore.teamMemberStore.fetchUserTeamMembersByPublicId();
            case 10:
              _context2.next = 12;
              return this.rootStore.memberStore.updateLastLogin(workspace.id);
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function selectWorkspace(_x2) {
        return _selectWorkspace.apply(this, arguments);
      }
      return selectWorkspace;
    }()
    /**
     * Calls the `fn` when a workspace is selected, both at first and when switching.
     *
     * @param {*} fn
     */
    )
  }, {
    key: "onWorkspaceSelected",
    value: function onWorkspaceSelected(fn) {
      var _this3 = this;
      // Only trigger once we have a member ID.
      if (this.member && this.member.id) {
        fn(this.workspace, this.member);
      }
      reaction(
      // Causes the reaction to trigger everytime the `member` getter resolves to a new member instance.
      // This works because LibX ensures the same instance is always reused for the same entity. WINNING!
      function () {
        return _this3.member;
      }, function (member) {
        return member && member.id && fn(_this3.workspace, member);
      });
      return this;
    }

    /**
     * Calls the `fn` when switching workspaces. Does not trigger for the initial workspace
     * selection.
     *
     * @param {*} fn
     */
  }, {
    key: "onWorkspaceSwitched",
    value: function onWorkspaceSwitched(fn) {
      return this.onWorkspaceSelected(after(2, fn));
    }
  }]);
}(Store), _descriptor = _applyDecoratedDescriptor(_class.prototype, "workspace", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "user", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "user"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "member", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "member"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "teamMembers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "teamMembers"), _class.prototype), _class);
export { SessionStore as default };
export function toStream(expression) {
  var fireImmediately = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Observable(function (observer) {
    var computedValue = computed(expression);
    return reaction(function () {
      return computedValue.get();
    }, function (newValue) {
      return observer.next(newValue);
    }, {
      fireImmediately: fireImmediately
    });
  });
}
//# sourceMappingURL=SessionStore.js.map
